/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { CardContainer } from "../../components/page-skeleton/CardContainer";
import { PageWrapper } from "../../components/page-skeleton/PageWrapper";
import * as authSelectors from "../auth/authSelectors";
import { useSelector } from "react-redux";
import { PageHeader } from "../../components/page-skeleton/PageHeader";
import { orgsWithAutoCampaigns, useIsOrganization } from "../../util";
import { CardBody } from "../../components/page-skeleton/CardBody";
import { SecondaryNavigationLink } from "../../components/SecondaryNavigationLink";
import { Navigate, Outlet, useLocation } from "react-router";
import { InfoBanner } from "../../components/InfoBanner";
import { routes } from "../../appRoutingHelpers";
import { config } from "../../config";

const additionalContainerStyle = css`
  padding-bottom: 24px;
`;

const tabsWrapperStyle = css`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  width: 100%;
  max-width: 1200px;
`;

export const AutoCampaignsLayout = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const showAutoCampaigns = useIsOrganization(orgsWithAutoCampaigns);
  const location = useLocation();

  // Temporarily only showing for Noahs
  if (!showAutoCampaigns && config.environment === "production") {
    return <Navigate to={routes.home(organizationKeyName)} />;
  }

  if (location.pathname === routes.autoCampaigns(organizationKeyName)) {
    return <Navigate to={routes.campaigns(organizationKeyName)} />;
  }

  return (
    <>
      <PageWrapper>
        <CardContainer additionalStyling={additionalContainerStyle}>
          <PageHeader
            title="Auto campaigns and product groups"
            subtitle="Manage your product groups and auto campaigns"
          />
          <CardBody>
            <InfoBanner>
              Auto campaigns: Auto campaigns is automatically applied to an
              order, based on what products are in the user’s basket. An auto
              campaign consists of groups of products that, when combined,
              trigger a discount to the user. You can create auto campaigns
              below. To use an auto campaign, add it to a menu.
            </InfoBanner>
          </CardBody>
        </CardContainer>
        <div css={tabsWrapperStyle}>
          <SecondaryNavigationLink
            to={routes.campaigns(organizationKeyName)}
            end={true}
          >
            Auto campaigns
          </SecondaryNavigationLink>
          <SecondaryNavigationLink
            to={routes.productGroups(organizationKeyName)}
            end={true}
          >
            Product groups
          </SecondaryNavigationLink>
        </div>
      </PageWrapper>
      <Outlet />
    </>
  );
};
